export default __webpack_public_path__ + "static/media/army_61.e57f548d.jpg";